import React from 'react'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Collapse from '@material-ui/core/Collapse'
import { withTranslation } from 'react-i18next'
import { styles } from './styles'
import { TFunction } from 'i18next'
import arrow from '../../../assets/images/arrow.png'

interface HelpPageDropDownProps {
  switchTab: Function
  t: TFunction
}

const HelpPageDropDown = ({ t, switchTab }: HelpPageDropDownProps) => {
  const classes = styles()

  const [open, setOpen] = React.useState(false)
  const [name, setName] = React.useState(t('help.helpAndTipsTab.heading'))

  const handleClick = () => {
    setOpen(!open)
  }

  const handleListItemClick = (event, index) => {
    setName(event.currentTarget.children[0].innerText)
    setOpen(!open)
    switchTab(event, index)
  }

  return (
    <>
      <List className={classes.root}>
        <ListItem button onClick={handleClick}>
          <ListItemText>{name}</ListItemText>
          <img
            src={arrow}
            className={classes.image}
            alt={t('imageAlts.downArrow')}
          />
        </ListItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem
              button
              onClick={e => handleListItemClick(e, 0)}
              className={classes.item}
            >
              <ListItemText> {t('help.helpAndTipsTab.heading')}</ListItemText>
            </ListItem>
            <ListItem
              button
              onClick={e => handleListItemClick(e, 1)}
              className={classes.item}
            >
              <ListItemText> {t('help.faqsTab.heading')}</ListItemText>
            </ListItem>
          </List>
        </Collapse>
      </List>
    </>
  )
}

export default withTranslation()(HelpPageDropDown)
